var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171 -514)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.75,1.649,3.911,6.417,0,4.6,9.666.078a.832.832,0,0,1,.7,0Z",
    transform: "translate(171.917 514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.667,2.253,4.4,7.333.556,5.441,0,5.159,10.1,0l.556.281Z",
    transform: "translate(177.417 516.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.083,5.02l-.011,10.564L.446,10.519A.849.849,0,0,1,0,9.773V0L4.079,2.026V5.589a.816.816,0,1,0,1.632,0V2.85l.544.267Z",
    transform: "translate(171 520.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.072,0,.011,5,0,15.583l10.083-5.3Z",
    transform: "translate(182.917 520.417)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.1401f51be5c98ea228e5452ef75d71d4.svg";
export { ForwardRef as ReactComponent };